import { Injectable, InjectionToken, Provider } from '@angular/core';
import { CreateAdditionalAssignmentBody } from '../app-types/additional-assignment';
import { CreateApiAdditionalAssignmentBody } from '../api-types/additional-assignment.api';
import { transformCreateAdditionalAssignmentToApiCreateAdditionalAssignmentBody } from '../transformers/additional-assignment.transform';
import { BaseRequestService } from './base-request.service';

export const ADDITIONAL_ASSIGNMENT_API = new InjectionToken<AdditionalAssignmentProvider>('ADDITIONAL_ASSIGNMENT_API');

@Injectable()
export class AdditionalAssignmentApi extends BaseRequestService implements AdditionalAssignmentProvider {
	public create = async (
		clientId: number | string,
		assignmentId: number | string,
		data: CreateAdditionalAssignmentBody,
	) => {
		const body = transformCreateAdditionalAssignmentToApiCreateAdditionalAssignmentBody(data);
		return this.post<{ id: number }, CreateApiAdditionalAssignmentBody>(
			`clients/${clientId}/assignments/${assignmentId}/additionalAssignments`,
			body,
		);
	};

	public delete = async (clientId: number | string, additionalAssignmentId: number | string) => {
		await this.remove<void>(`clients/${clientId}/additionalAssignments/${additionalAssignmentId}`);
	};
}

export const provideAdditionalAssignmentApi: Provider = {
	provide: ADDITIONAL_ASSIGNMENT_API,
	useClass: AdditionalAssignmentApi,
};

export interface AdditionalAssignmentProvider {
	create(
		clientId: number | string,
		assignmentId: number | string,
		data: CreateAdditionalAssignmentBody,
	): Promise<{ id: number }>;
	delete(clientId: number | string, additionalAssignmentId: number | string): Promise<void>;
}
